'use strict';

// Vue
import Vue from 'vue';

// Services
import { arrayLoop } from 'utils/array';

// Modules
import ModuleButton from './Button';
import ModuleIcon from './Icon';
import ModuleError from './Error';
import ModuleForm from './Form';
import ModuleFieldset from './Fieldset';
import ModuleLink from './Link';
import ModuleLogo from './Logo';

// globalModules
const globalModules = {
  'module-button': ModuleButton,
  'module-icon': ModuleIcon,
  'module-error': ModuleError,
  'module-form': ModuleForm,
  'module-fieldset': ModuleFieldset,
  'module-link': ModuleLink,
  'module-logo': ModuleLogo,
};

// @function registerGlobalModules()
// Loop through globalModules and register each as a component
export const registerGlobalModules = () => {
  arrayLoop(globalModules, (name, module) => Vue.component(name, module));
};



// WEBPACK FOOTER //
// ./client/components/index.js